// extracted by mini-css-extract-plugin
export default {"integrationPage__input":"integrations_integrationPage__input__GViaM","integrationPage__button":"integrations_integrationPage__button__b7age"};